<template>
    <div>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">REPORTE DE TRAZABILIDAD</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                </v-row>
            </v-card-text>
            <modal-ayuda></modal-ayuda>
            <v-card-text>
                <v-row>
                    <v-col cols="1" class="form-group">
                    </v-col>
                    <v-col cols="1" class="form-group">
                        <v-text-field label="Guía" v-model="guia" ></v-text-field>
                    </v-col>
                    <v-col cols="1">
                        <v-text-field label="Lote" v-model="lote" ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <span><b>Fecha Producción: </b></span>
                        <date-picker class="float-right" v-model="fecha" range-separator="|" range placeholder="Fecha Producción" format="DD-MM-YYYY" :default-value="fecha" valueType="YYYY-MM-DD"></date-picker>
                    </v-col>
                    <v-col cols="1">
                        <v-btn dark small color="green darken-1" class="float-right" @click="cargar_traza"><v-icon>search</v-icon> Buscar</v-btn>
                    </v-col>
                    <v-col cols="1">
                        <v-btn dark small color="green darken-1" class="float-right" @click="exportarExcel"><v-icon>file_download</v-icon> Excel</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <div class="table-wrap">
                <v-simple-table
                    fixed-header
                    width="100%"
                    height="90vh"
                >
                <template v-slot:default>
                    
                    <thead>
                        <tr>
                            <th class="text-center cabecera">
                                Fecha Hora Recepción
                            </th>
                            <th class="text-center cabecera">
                                Tiempo Camión
                            </th>
                            <th class="text-center cabecera">
                                Fecha Guía
                            </th>
                            <th class="text-center cabecera">
                                Ticket
                            </th>
                            <th class="text-center cabecera">
                                Proveedor
                            </th>
                            <th class="text-center cabecera">
                                Planta
                            </th>
                            <th class="text-center cabecera">
                                Código Planta
                            </th>
                            <th class="text-center cabecera">
                                N° Guía
                            </th>
                            <th class="text-center cabecera">
                                Especie
                            </th>
                            <th class="text-center cabecera">
                                Restricción
                            </th>
                            <th class="text-center cabecera">
                                Informado Kg
                            </th>
                            <th class="text-center cabecera">
                                Romana Kg
                            </th>
                            <th class="text-center cabecera">
                                Linea
                            </th>
                            <th class="text-center cabecera">
                                Fecha Elaboración
                            </th>
                            <th class="text-center cabecera">
                                Nro Lote
                            </th>
                            <th class="text-center cabecera">
                                Maxisaco
                            </th>
                            <th class="text-center cabecera">
                                Marin Trust
                            </th>
                            <th class="text-center cabecera">
                                Kgs MMPP
                            </th>
                            <th class="text-center cabecera">
                                Origen Repaso
                            </th>
                            <th class="text-center cabecera">
                                Observaciones
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="d in trazas" :key="d.id" :class="`${d.ticket_r != '' ? 'fila_r' : ''} ${d.restriccion === 'UE' && 'fila_ue'}`">
                            <td class="text-center">
                                {{ d.f_recepcion }}  {{ d.h_recepcion }}
                            </td>
                            <td class="text-center">
                                {{ d.tiempo }} <br>
                            </td>
                            <td class="text-center">
                                {{d.f_guia }}
                            </td>
                            <td class="text-center">
                                {{ d.ticket_r != '' ? d.ticket_r : d.ticket }}
                            </td>
                            <td class="text-center">
                                {{d.proveedor }}
                            </td>
                            <td class="text-center">
                                {{ d.planta }}
                            </td>
                            <td class="text-center">
                                {{ d.cod_planta }}
                            </td>
                            <td class="text-center">
                                {{ d.guia }}
                            </td>
                            <td class="text-center">
                                {{ d.especie }}
                            </td>
                            <td class="text-center">
                                {{ d.restriccion }}
                            </td>
                            <td class="text-center">
                                {{ d.informado }}
                            </td>
                            <td class="text-center">
                                {{ d.romana }}
                            </td>
                            <td class="text-center">
                                {{ d.linea }}
                            </td>
                            <td class="text-center">
                                {{ d.fecha }}
                            </td>
                            <td class="text-center">
                                {{ d.lote }}
                            </td>
                            <td class="text-center">
                                {{ d.maxis }}
                            </td>
                            <td class="text-center">
                                {{ d.m_trust }}
                            </td>
                            <td class="text-center">
                                {{ d.parcial }}
                            </td>
                            <td class="text-center">
                                {{ d.repaso }}
                            </td>
                            <td class="text-center">
                                {{ d.restr_ue }}. {{ d.obs }}
                                <v-btn icon @click="abrirModalComentario(d)">
                                    <v-icon v-if="d.obs == null || d.obs == ''" color="black darken-4">insert_comment</v-icon>
                                    <v-icon v-if="d.obs != null && d.obs != ''" color="red lighten-1">insert_comment</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </tbody>
                </template>
                </v-simple-table>
            </div>
            <modal-comentar-traza></modal-comentar-traza>
        </v-card>
    </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import DatePicker from 'vue2-datepicker';
import Modal_Comentar_Traza from '@/components/shared/Modal_Comentar_Traza.vue';

import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from "../../components/shared/ModalAyudas.vue";
export default {
    data:() => ({
        trazas: [],
        fecha: null,
        lote: '',
        guia:'',
        url:'',
        url_excel: ''
    }),
    mounted(){
        this.fecha =  this.moment().format('YYYY-MM-DD');

    },
    methods:{
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Generar Trazabilidad`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestra el reporte de trazabilidad de cada lote.`},
                {   tipo:`label`,   texto:`- Se puede filtrar el reporte por guía, por lote y por fecha de producción. Al pulsar el botón "Buscar", se realizará la búsqueda según los filtros indicados.`},
                {   tipo:`label`,   texto:`- Adicionalmente, se puede exportar en Excel los reportes según los filtros pulsando el botón "Excel".`},
            ];
            Event.$emit('mostrar_alert',jiji);
        },
        async cargar_traza(){
            this.mostrarLoading({titulo:'Buscando Información...',color:'green'});
            if (this.guia == '') this.guia = 0;
            if (this.lote == '') this.lote = 0;
            let fecha_ini = this.fecha[0];
            let fecha_fin = this.fecha[1];
            let url = `${this.base_url}traza/traza_dia/${fecha_ini}/${fecha_fin}/${this.guia}/${this.lote}`;
            await this.axios.get(url, this.headers).then((res)=>{
                this.trazas = res.data.data;
                this.url_excel = res.data.url_excel;
                console.log('download_url',this.download_url);
            console.log('url_excel',this.url_excel);
            }).catch((e)=>{
                console.log(e);
            });
            this.ocultarLoading();
        },
        exportarExcel(){
            console.log('download_url',this.download_url);
            console.log('url_excel',this.url_excel);
            window.location.href = this.download_url + this.url_excel;
        },
        async grabar_incremento(d, f){
            let url = `${this.base_url}despachos_harina/grabar/incremento`;
            if(typeof d[f] == "boolean") d[f] = d[f] == true ? 1:0;
            let body = {
                despacho_pts_id: d.id,
                incremento: d.incremento,
                campo: f,
                valor: d[f]
            }
            await this.axios.post(url, body, this.headers).then((res)=>{
                console.log(res.data.data);
            }).catch((e)=>{
                console.log(e);
            });
        },
        abrirModalComentario(registro){
            console.log('registro', registro);
            Event.$emit('abrir_modal_comentar_traza',registro);
        },
        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },
    computed:{
        ...mapState(['base_url', 'user', 'headers', 'download_url']),
    },
    components:{
        DatePicker,
        'modal-comentar-traza':Modal_Comentar_Traza,
        'modal-ayuda': ModalAyudas,
    }
}
</script>
<style scoped>
    td{
        padding: 0em 1em;
        border-bottom:1px solid #01579B !important;
    }
    .fila_r{background-color: #b2dfdb;}

    .fila_ue{background-color: #F28773;}
    .table-wrap { width: 100%;  overflow-x: auto;  }
    .tablet>thead>tr>th { background-color: white; position: sticky; position: -webkit-sticky; top: 0; z-index: 2;} 

</style>
